<template>
    <div>
        <Head :title="title" />

        <jet-banner />

        <div class="lg:flex">
            <div class="content flex-1">
                <main>
                    <slot></slot>
                </main>
            </div>
        </div>
    </div>
</template>

<script>
    import { Head } from '@inertiajs/inertia-vue3';
    import JetBanner from '@/Jetstream/Banner';

    export default {
        props: {
            title: String,
        },

        components: {
            Head,
            JetBanner
        },

    }
</script>

<style>
body {
    @apply text-gray-darker;
    font-size: 16px;
}

@media screen and (min-width: 1024px) {
    .content {
        padding-left: 0;
    }
}

h1 {
    @apply text-3xl font-bold;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

textarea,
input[type=text],
input[type=email],
input[type=date],
input[type=datetime],
input[type=password],
input[type=search],
input[type=tel],
input[type=time],
input[type=url],
input[type=number] {
    @apply py-1 border border-gray focus:border-gray focus:outline-none focus:ring-green;
}

button {
    @apply border border-gray bg-gray-light px-3 py-1 font-bold focus:outline-none focus:ring-green focus:ring-1 hover:bg-gray;
}

.button-group {
    @apply flex;
}

.button-group button,
.button-group input {
    @apply relative focus:z-50;
}

.button-group button:first-child {
    @apply rounded-tl rounded-bl border-r-0;
}

.button-group button:last-child {
    @apply rounded-tr rounded-br border-l-0;
}

.button-group select {
    @apply py-1 bg-gray-light border border-r-0 border-gray rounded-tl rounded-bl focus:ring-green focus:ring-opacity-50 focus:outline-none focus:border-gray focus:z-50 relative cursor-pointer;
}

input.quantity {
    max-width: 65px;
}

.form-group {
    @apply my-6;
}
</style>